import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import Routing from "./routing";
import CustomTheme from "./theme";
import { Provider, useDispatch } from "react-redux";
import store from "./redux/store";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchRequest as fetchHospitalConfig } from './redux/modules/hospitalConfig/slice';

function HospitalConfigBootstrapper() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchHospitalConfig());
  }, [dispatch]);
  return null;
}

function App() {
  return (
    <>
      <Provider store={store}>
        <HospitalConfigBootstrapper />
        <BrowserRouter>
          <CustomTheme>
            <Routing />
          </CustomTheme>
        </BrowserRouter>
      </Provider>
      <ToastContainer />
    </>
  );
}

export default App;